'use client'

import { FormBlock2 } from '@/blocks/Form/Component2'
import type { SerializedEditorState } from '@payloadcms/richtext-lexical/lexical'

interface FormIslandProps {
  form: any
  title?: SerializedEditorState | null
}

/**
 * Client-side island for the hero form.
 * This is the ONLY part of HeroBlock4 that ships JS to the client.
 * Everything else (background image, text, buttons) is server-rendered with zero JS.
 */
export default function FormIsland({ form, title }: FormIslandProps) {
  return (
    <FormBlock2
      form={
        typeof form === 'object' && form !== null && 'value' in form ? (form as any).value : form
      }
      enableIntro={false}
      hideImageSection={true}
      bareForm={true}
      title={title || undefined}
    />
  )
}
